import { idb } from "../db/index.ts";
import type { Player } from "../../common/types.ts";

const advStatsSave = async (
	players: any[],
	playersRaw: Player[],
	updatedStats: Record<string, number[] | number[][]>,
) => {
	const keys = Object.keys(updatedStats);
	const playersByPid = new Map(playersRaw.map((p) => [p.pid, p]));
	await Promise.all(
		players.map(async ({ pid }, i) => {
			const p = playersByPid.get(pid);

			if (p) {
				const ps = p.stats.at(-1);

				if (ps) {
					for (const key of keys) {
						if (!Number.isNaN(updatedStats[key]![i])) {
							ps[key] = updatedStats[key]![i];
						}
					}

					await idb.cache.players.put(p);
				}
			}
		}),
	);
};

export default advStatsSave;
